var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"hotelDetailsWrapper"}},[(_vm.uspBannerVisible)?_c('USPBanner'):_vm._e(),_vm._v(" "),_c(_vm.component,_vm._b({tag:"component"},'component',{ hotel: _vm.hotel, marker: _vm.marker, teaser: _vm.teaser, hotelDetails: _vm.hotelDetails },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }